import React from 'react';
import {Card, CardBody, CardHeader, Col, Collapse, Row} from "reactstrap";
import {Button as SementicBtn, Button, Card as Cardx, Dropdown, Form, Icon} from 'semantic-ui-react'
import "./Style.css";
import TxtLbl from "../../../../components/Input/Input/TxtLbl";
import TxtAreaLbl from "../../../../components/Input/TextArea/TextAreaLbl";
import Lbl from "../../../../components/Label/Lbl";
import {DatePicker, Empty, TimePicker, Tooltip} from "antd";
import {MDBDataTable} from "mdbreact";
import NewEvent from "../../../Event/ManageEvent/AddViewModify/CreateNewEvent";
import UpdateModel from '../Update/index';
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import * as innerRoutes from "../../ViewAllPublicLayer/InnerRoutings/InnerRoutes";
import Cookies from "js-cookie";
import axios from "../../../../axios/axios_visitortag";
import apiConfig from "../../../../axios/axios_api_services";
import * as common from "../../../../const/Common/CommonFunc";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../assets/img/sweet/question.svg";
import Job from "../../../../components/IcsFileGenerator/ics";
import {notifyMessage} from "../../../../const/Common/CommonFunc";

let xc = "";

class App extends React.Component{

  state = {
    isOpenEditModel: false,
    meetingObj: null,


    hostId: "",
    hostName: "",

    meetingRefNo: "",
    meetingTitle: "",
    meetingDescription: "",
    meetingDate: "",
    meetingSTime: "",
    meetingETime: "",
    meetingBuilding: "",
    meetingBuildingId: "",
    meetingFloor: "",
    meetingPurpose: "",
    meetingFrequency: "",
    meetingUntil: "",

    oldMeetingTitle: "",
    oldMeetingDescription: "",
    oldMeetingBuilding: "",
    oldMeetingFloor: "",
    oldMeetingPurpose: "",
    oldMeetingDate: "",
    oldMeetingSTime: "",
    oldMeetingETime: "",
    oldMeetingFrequency: "",
    oldMeetingUntil: "",
    oldAttendeeListX: [],

    attendeeChange: true,
    attendeeUserId: "",
    attendeeSearch: "",
    attendeeType: "NIC",
    attendeeTitle: "Mr",
    attendeeIdentity: "",
    attendeeFName: "",
    attendeeLName: "",
    attendeeMobile: "",
    attendeeCompany: "",
    attendeeEMail: "",

    attendeeValidMobile: false,
    attendeeValidEMail: false,
    attendeeValidIdentity: true,

    repeatOpen: false,
    attendeesList: [],
    meetingFloorList: [],
    updateBtnDisable: true,
    t: [],

    // meetingObj:{
    //   refNo : "3254236748hytr8568525",
    //   isReccurentMeeting : false,
    //   visitors : [
    //     {
    //       meetingVisitorId : 2,
    //       user : {
    //         firstName : "kk",
    //         lastName : "kk",
    //         identificationValue : "123",
    //         mobile : "xxxxxxxxxx",
    //         email : "xxxxxxxxxxx",
    //         companyName : "xxxxxxxxxxx",
    //         title : "xxxxxxxxxx",
    //       }
    //     }
    //   ],
    //   meetingSeries : [
    //     {
    //       hostA : 1,
    //       refNo : "3254236748hytr8568525",
    //       floor : {
    //         floorId : 2,
    //         description : "floor description",
    //         floorColour : "Yellow",
    //         level : "level 02",
    //         status : "string",
    //         buildingId: 24
    //       },
    //       building : {
    //         buildingId : 24,
    //
    //         code : "string",
    //         levelCount : 15,
    //         location : "Colombo 06",
    //         name : "park land",
    //         status : "string",
    //         branchId : 45
    //       },
    //       title : "weekly team gathering",
    //       description : "weekly meeting",
    //       startTime : "2020-07-01 09:00:00",
    //       endTime : "2020-07-29 11:00:00"
    //     }
    //   ]
    // }
  }

  componentDidMount() {
    if (this.props.usr_obj !== null || this.props.usr_obj !== "") {
      let meeting = this.props.meetingObj;
      if(meeting !== null) {

        let untilDateTime = meeting.meetingSeries[meeting.meetingSeries.length-1].endTime;
        let untilDateTimeArray = untilDateTime.split(" ");
        let meetingUntilDate = untilDateTimeArray[0];
        let end_time = untilDateTimeArray[1];
        let meetingETime = end_time;

        let start_date_time1 = meeting.meetingSeries[0].startTime;
        let start_date_time_array1 = start_date_time1.split(" ");
        let start_date1 = start_date_time_array1[0];
        let start_time = start_date_time_array1[1];
        let meetingSDate = start_date1;
        let meetingSTime = start_time;

        let isRecurring = false;
        isRecurring = this.props.meetingObj.recurrentMeeting;

        let attendeesList = this.props.meetingObj.visitors;
        const attendeesListx = this.props.meetingObj.visitors;
        xc = this.props.meetingObj.visitors;
        let diff = "DAILY";
        if(meeting.meetingSeries.length > 1) {
          let start_date_time1 = meeting.meetingSeries[0].startTime;
          let start_date_time_array1 = start_date_time1.split(" ");
          let start_date1 = start_date_time_array1[0];

          let start_date_time2 = meeting.meetingSeries[1].startTime;
          let start_date_time_array2 = start_date_time2.split(" ");
          let start_date2 = start_date_time_array2[0];

          var date1 = new Date(start_date1);
          var date2 = new Date(start_date2);

          var Difference_In_Time = date2.getTime() - date1.getTime();

          var difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

          if(difference_In_Days === 7) {
            diff = "WEEKLY";
          }else if(difference_In_Days === 30) {
            diff = "MONTHLY"
          }else if(difference_In_Days === 365 || difference_In_Days === 366){
            diff = "YEARLY"
          }
        }

        // let fl = this.onHandleChangeBuildingFloorAuto(meeting.meetingSeries[0].building.building_id);

        this.setState({
          hostId: this.props.usr_obj.userId,
          hostName: "",

          meetingRefNo: meeting.refNo,
          meetingTitle: meeting.meetingSeries[0].title,
          meetingDescription: meeting.meetingSeries[0].description,
          meetingDate: meetingSDate,
          meetingSTime: meetingSTime,
          meetingETime: meetingETime,
          meetingBuilding: meeting.meetingSeries[0].building !== null ? meeting.meetingSeries[0].building.building_id : "N/A",
          meetingBuildingId: "",
          meetingFloor: meeting.meetingSeries[0].floor !== null ? meeting.meetingSeries[0].floor.floor_id : "N/A",
          meetingPurpose: meeting.meetingSeries[0].visitingPurpose,
          meetingFrequency: diff,
          meetingUntil: meetingUntilDate,

          oldMeetingTitle: meeting.meetingSeries[0].title,
          oldMeetingDescription: meeting.meetingSeries[0].description,
          oldMeetingBuilding: meeting.meetingSeries[0].building !== null ? meeting.meetingSeries[0].building.building_id : "N/A",
          oldMeetingFloor: meeting.meetingSeries[0].floor !== null ? meeting.meetingSeries[0].floor.floor_id : "N/A",
          oldMeetingPurpose: meeting.meetingSeries[0].visitingPurpose,
          oldMeetingDate: meetingSDate,
          oldMeetingSTime: meetingSTime,
          oldMeetingETime: meetingETime,
          oldMeetingFrequency: diff,
          oldMeetingUntil: meetingUntilDate,

          attendeeSearch: "",
          attendeeType: "NIC",
          attendeeTitle: "Mr",
          attendeeIdentity: "",
          attendeeFName: "",
          attendeeLName: "",
          attendeeMobile: "",
          attendeeCompany: "",
          attendeeEMail: "",

          attendeeValidMobile: false,
          attendeeValidEMail: false,
          attendeeValidIdentity: true,

          repeatOpen: isRecurring,
          attendeesList: attendeesList,
          meetingFloorList: [],
        });
      }
    }
  }

  componentWillMount(){
    let meetingObj = this.props.meetingObj;
    if(meetingObj !== null) {
      this.setState({
        meetingObj: meetingObj
      })
    }else {
      this.props.history.push(innerRoutes.allMeetings);
    }
  }

  openUpdateModal = () => {
    let refNo = this.props.meetingObj.refNo;
    let s = refNo.substr(refNo.length - 7);
    if(s === "_portal") {
      this.setState({
        isOpenEditModel: true
      });
    } else {
      common.notifyMessage("Can't update this meeting via the portal because this meeting is not scheduled by the portal");
    }

  }

  deleteMeeting = () => {
    let refNo = this.props.meetingObj.refNo;
    let s = refNo.substr(refNo.length - 7);
    if(s === "_portal") {
      this.deleteMeeting_();
    } else {
      common.notifyMessage("Can't cancel this meeting via the portal because this meeting is not scheduled by the portal");
    }
  }

  deleteMeeting_ = () => {
    swal({
      title: "Are you sure you want to cancel?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Yes",
          value: "action",
          className: "okay-btn"
        }
      },
    })
      .then((value) => {
        switch (value) {
          case "action":
            // this.sendToBackEnd();
            this.deleteICS();
            break;
          default:
        }
      });
  }

  deleteICS = () => {

    let cal = Job();
    let dateArray = (this.state.meetingDate).split("-");
    let timeArray = (this.state.meetingSTime).split(":");
    let untilArray = (this.state.meetingUntil).split("-");
    let days = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];
    let d = new Date(this.state.meetingDate);
    let dayName = days;
    if (this.state.meetingFrequency !== 'DAILY') {
      dayName = [days[d.getDay()]];
    }

    let rule = {
      freq: this.state.meetingFrequency,
      interval: 1,
      dtstart: this.state.meetingDate+" "+this.state.meetingSTime,
      until: this.state.meetingUntil,
      byday : dayName
    };

    let org_name = this.props.usr_obj.firstName + ' ' + this.props.usr_obj.firstName;
    let org_mail = this.props.usr_obj.email;
    let att_list = [];
    this.state.attendeesList.map((val, index) => {
      att_list.push(val.email);
    });

    let meetingIcs = null;

    if (!this.props.meetingObj.recurrentMeeting) {
      try {
        // meetingIcs = cal.addEvent(this.state.meetingTitle, this.state.meetingDescription, this.props.usr_obj.corporates[0].corporateId,
        //   this.state.meetingDate+" "+this.state.meetingSTime, this.state.meetingDate+" "+this.state.meetingETime);
        meetingIcs = cal.addEvent(this.state.meetingTitle, this.state.meetingDescription, "location",
          this.state.meetingDate + " " + this.state.meetingSTime, this.state.meetingDate + " " + this.state.meetingETime, null, org_name, org_mail, att_list, 3, this.state.meetingRefNo);

        this.sendToBackEnd(meetingIcs);

      } catch (e) {
        notifyMessage("Something went wrong!", 1, 3);
      }

    } else {
      try {
        meetingIcs = cal.addEvent(this.state.meetingTitle, this.state.meetingDescription, this.props.usr_obj.corporates[0].corporateId,
          this.state.meetingDate + " " + this.state.meetingSTime, this.state.meetingDate + " " + this.state.meetingETime, rule, org_name, org_mail, att_list, 3, this.state.meetingRefNo);

        this.sendToBackEnd(meetingIcs);
      } catch (e) {
        notifyMessage("Something went wrong!", 1, 3);
      }

    }

  }

  sendToBackEnd = (ics) => {

    let icsContent = {
      icsContent: ics
    }

    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    let corporateId = this.props.usr_obj.corporates[0].corporateId;
    let refNo = this.props.meetingObj.refNo;
    this.props.spinnerHandler(true);
    axios.patch(apiConfig.HOST_DELETE_MEETING({corporateId: corporateId, refNo: refNo}), icsContent, { headers: headers })
      .then(response => {
        let result = response.data.success;
        if (result) {
          common.warningAlert("Meeting has been cancelled", 0);
          this.props.history.push(innerRoutes.allMeetings);
        } else {
          this.props.spinnerHandler(false);
          common.warningAlert(response.data.message, 1)
        }
      }).catch(async error => {
      if (error.response.status === 417) {
        common.warningAlert("Something went wrong!", 1);
      } else {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendToBackEnd();
        } else {
          this.props.spinnerHandler(false)
        }
      }

    })
      .finally(fin => {
        this.props.spinnerHandler(false);
      })
  }

  render() {

    let meetingObj = this.props.meetingObj;

    //-------------------------------------------------------------------------------------------------------------------------------------------

    let meetingTitle = "";
    let meetingDescription = "";
    let meetingSTDate = "";
    let meetingSTime = "";
    let meetingETime = "";
    let isRecurring = false;
    let building = "";
    let floor = "";
    let purpose = "";
    let diff = "DAILY";
    let untilDate = "";

    if(meetingObj !== null) {
      meetingTitle = meetingObj.meetingSeries[0].title;
      meetingDescription = meetingObj.meetingSeries[0].description;
      isRecurring = meetingObj.recurrentMeeting;
      let meetingBuildingObj = meetingObj.meetingSeries[0].building;
      if(meetingBuildingObj!==null) {
        building = `${meetingBuildingObj.name} ${meetingBuildingObj.location !== null ? `,${meetingBuildingObj.location}` : `` }` ;
      } else {
        building = "N/A";
      }
      if(meetingObj.meetingSeries[0].floor!==null) {
        floor = meetingObj.meetingSeries[0].floor.description;
      } else {
        floor = "N/A";
      }
      purpose = meetingObj.meetingSeries[0].visitingPurpose !== null ? meetingObj.meetingSeries[0].visitingPurpose : "N/A";
      let untilDateTime = meetingObj.meetingSeries[meetingObj.meetingSeries.length-1].endTime;
      let untilDateTimeArray = untilDateTime.split(" ");
      untilDate = untilDateTimeArray[0];
      let end_time = untilDateTimeArray[1];
      meetingETime = end_time;

      let start_date_time1 = meetingObj.meetingSeries[0].startTime;
      let start_date_time_array1 = start_date_time1.split(" ");
      let start_date1 = start_date_time_array1[0];
      let start_time = start_date_time_array1[1];
      meetingSTDate = start_date1;
      meetingSTime = start_time;

      if(meetingObj.meetingSeries.length > 1) {
        let start_date_time1 = meetingObj.meetingSeries[0].startTime;
        let start_date_time_array1 = start_date_time1.split(" ");
        let start_date1 = start_date_time_array1[0];

        let start_date_time2 = meetingObj.meetingSeries[1].startTime;
        let start_date_time_array2 = start_date_time2.split(" ");
        let start_date2 = start_date_time_array2[0];

        var date1 = new Date(start_date1);
        var date2 = new Date(start_date2);

        var Difference_In_Time = date2.getTime() - date1.getTime();

        var difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

        if(difference_In_Days === 7) {
          diff = "WEEKLY";
        }else if(difference_In_Days === 30) {
          diff = "MONTHLY"
        }else if(difference_In_Days === 365 || difference_In_Days === 366){
          diff = "YEARLY"
        }
      }
    }

    let attendees_rows = [];
    let attendees_col = [
      {
        label: 'Identification',
        field: 'id',
        sort: 'asc'
      },
      {
        label: 'First Name',
        field: 'fname',
        sort: 'asc'
      },
      {
        label: 'Last Name',
        field: 'lname',
        sort: 'asc'
      },
      {
        label: 'Mobile',
        field: 'mobile',
        sort: 'asc'
      }

    ];

    if(meetingObj !== null) {
      if (meetingObj.visitors.length !== 0) {
        meetingObj.visitors.map((attendee, index) => {
          const obj = {
            id: attendee.identificationValue,
            fname: attendee.firstName,
            lname: attendee.lastName,
            mobile: attendee.mobile
          };

          attendees_rows.push(obj);
        })
      }
    }


    let attendees_table_data = { columns: attendees_col, rows: attendees_rows };

    let recurring_meeting_rows = [];
    let recurring_meeting_col = [
      {
        label: 'date',
        field: 'date',
        sort: 'asc'
      },
      {
        label: 'State',
        field: 'state',
        sort: 'asc'
      }
    ];

    if(meetingObj !== null) {
      if (meetingObj.meetingSeries.length !== 0) {
        meetingObj.meetingSeries.map((meeting, index) => {

          let start_date_time = meeting.startTime;
          let start_date_time_array = start_date_time.split(" ");
          let start_date = start_date_time_array[0];
          let CurrentDate = new Date();
          let GivenDate = new Date(start_date);
          let state = "Upcoming";
          if(GivenDate === CurrentDate) {
            state = <div className="ui yellow label">Today</div>;
          }else if(GivenDate > CurrentDate){
            state = <div className="ui green label">Upcoming</div>;
          }else{
            state = <div className="ui orange label">Held</div>;
          }

          const obj = {
            date: start_date,
            state: state
          };

          recurring_meeting_rows.push(obj);
        })
      }
    }

    let recurring_meeting_table_data = { columns: recurring_meeting_col, rows: recurring_meeting_rows };

    return(
      <div>
        {
          this.state.isOpenEditModel ? <UpdateModel hisProps={this.props} closeModal={()=>this.setState({isOpenEditModel:false})}/> : null
        }
        <div className="meetingUpdateDeleteButtonHolder">
            <Button positive onClick={this.openUpdateModal}><i aria-hidden="true" className="edit icon"></i>Edit</Button>
            <Button negative onClick={this.deleteMeeting}><i aria-hidden="true" className="trash alternate icon"></i>Cancel</Button>
        </div>
        <Row className="main-row-padding">
          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
            <Card>
              <CardHeader>
                Meeting Details - {"Meeting Name"}
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>
                  <Row>
                    <Col lg ={12} md={12}>

                      <Row>
                        <Col lg ={8} md={8}>

                          <Col lg={12} className="TimePickerCol">
                            <Lbl required>Title</Lbl>
                            <p>{meetingTitle}</p>

                          </Col>

                          <Col lg={12} className="TimePickerCol">
                            <Lbl required>Description</Lbl>
                            <textarea className={"meeting-desc"} disabled>{meetingDescription}</textarea>

                          </Col>


                          <Row className="TimePickerCol" style={{marginLeft: "2px"}}>
                            <Col lg={4} md={4} xs={4} className="TimePickerCol">
                              <Lbl required>Meeting Date</Lbl>
                              <p>{meetingSTDate}</p>

                            </Col>

                            <Col lg={4} md={4} xs={4} className="TimePickerCol">
                              <Lbl required>Start Time</Lbl>
                              <p>{meetingSTime}</p>

                            </Col>

                            <Col lg={4} md={4} xs={4} className="TimePickerCol">
                              <Lbl required>End Time</Lbl>
                              <p>{meetingETime}</p>

                            </Col>
                          </Row>

                          <Col lg={12} className="TimePickerCol">
                            <Lbl required>Is Recurring meeting</Lbl>
                            {isRecurring?<p><i aria-hidden="true" className="check circle icon"></i>YES - {diff} recurring until {untilDate}</p>:
                              <p><Icon name='times circle' />NO</p>}
                          </Col>

                        </Col>
                        <Col lg ={4} md={4}>
                          <Col lg={12} className="TimePickerCol">
                            <Lbl required>Building</Lbl>
                            <p>{building}</p>

                          </Col>
                          <Col lg={12} className="TimePickerCol">
                            <Lbl required>Floor</Lbl>
                            <p>{floor}</p>

                          </Col>
                          <Col lg={12} className="TimePickerCol">
                            <Lbl required>Purpose</Lbl>
                            <p>{purpose}</p>

                          </Col>


                        </Col>
                      </Row>

                    </Col>
                  </Row>
                </CardBody>
              </Collapse>
            </Card>
          </Col>
        </Row>

        {
          isRecurring?
            <Row className="main-row-padding">
              <Col xs="12" lg={"6"} md={"6"} className={"padd_grap"}>
                <Card>
                  <CardHeader>
                    Meeting Attendees
                  </CardHeader>
                  <Collapse isOpen={true} id="collapseExample">
                    <CardBody>
                      <Row>
                        <Col lg={12} md={12}>

                          <Row style={{marginTop: '20px'}}>
                            <Col lg ={12} md={12}>

                              {
                                true?
                                  <MDBDataTable
                                    searching={false}
                                    displayEntries={false}
                                    // paging={false}
                                    entries={5}
                                    responsive
                                    responsiveSm
                                    responsiveMd
                                    responsiveLg
                                    responsiveXl
                                    bordered
                                    hover
                                    data={attendees_table_data}
                                  />
                                  : <div className={"align-center fully-width"}>
                                    <Empty description={"Records not found"} className={"empty-icon"}/>
                                  </div>
                              }
                            </Col>
                          </Row>

                        </Col>
                      </Row>
                    </CardBody>
                  </Collapse>
                </Card>
              </Col>
              <Col xs="12" lg={"6"} md={"6"} className={"padd_grap"}>
                <Card>
                  <CardHeader>
                    Recurring meeting dates
                  </CardHeader>
                  <Collapse isOpen={true} id="collapseExample">
                    <CardBody>
                      <Row>
                        <Col lg={12} md={12}>
                          <Row style={{marginTop: '20px'}}>
                            <Col lg ={12} md={12}>

                              {
                                meetingObj!== ""?
                                  <MDBDataTable
                                    searching={false}
                                    displayEntries={false}
                                    // paging={false}
                                    entries={5}
                                    responsive
                                    responsiveSm
                                    responsiveMd
                                    responsiveLg
                                    responsiveXl
                                    bordered
                                    hover
                                    data={recurring_meeting_table_data}
                                  />
                                  : <div className={"align-center fully-width"}>
                                    <Empty description={"Records not found"} className={"empty-icon"}/>
                                  </div>
                              }
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </CardBody>
                  </Collapse>
                </Card>
              </Col>
            </Row>:
            <Row className="main-row-padding">
              <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
                <Card>
                  <CardHeader>
                    Meeting Attendees
                  </CardHeader>
                  <Collapse isOpen={true} id="collapseExample">
                    <CardBody>
                      <Row>
                        <Col lg={12} md={12}>

                          <Row style={{marginTop: '20px'}}>
                            <Col lg ={12} md={12}>

                              {
                                true?
                                  <MDBDataTable
                                    searching={false}
                                    displayEntries={false}
                                    // paging={false}
                                    entries={8}
                                    responsive
                                    responsiveSm
                                    responsiveMd
                                    responsiveLg
                                    responsiveXl
                                    bordered
                                    hover
                                    data={attendees_table_data}
                                  />
                                  : <div className={"align-center fully-width"}>
                                    <Empty description={"Records not found"} className={"empty-icon"}/>
                                  </div>
                              }
                            </Col>
                          </Row>

                        </Col>
                      </Row>
                    </CardBody>
                  </Collapse>
                </Card>
              </Col>
            </Row>
        }



      </div>

    );
  }

}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
  purpose_options_list: state.reception_SheduleMeetingReducer.visitors_purpose_options_list,
  all_building_list: state.reception_SheduleMeetingReducer.all_building_list,
  all_floor_list: state.reception_SheduleMeetingReducer.all_floor_list,
  meetingObj: state.hostReducer.meetingObj,
});

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    callAllBuildings: (data) => dispatch(actionCreator.callAllBuildingsForHost(data)), // Get All Buildings Of Corporate
    setMeetingHost: (data) => dispatch(actionCreator.setMeetingHost(data)),
    removeMeetingHost: () => dispatch(actionCreator.removeMeetingHost()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);

